import Factory from '../utils/factory'
import ObjectId from 'mongo-objectid'
import Item from './item'

export default Factory({
  id: () => new ObjectId().hex,
  label: null,
  sublabel: null,
  metadata: {
    area: null,
    hidePrice: false,
  },
  items: [Item],
  conditions: {
    if: [],
    ifnot: [],
  },
})
